import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ContentElement from './ContentElement.tsx';
import ContentElementV2 from './ContentVariation/ContentElementV2.tsx';
import Orderbump from './Orderbump';
import SkeletonEmpty from '../../Skeleton/SkeletonEmpty';
import { RootState } from '../../../redux/checkoutredux/store/checkoutStore';

interface BlockContentProps {
  loading: boolean;
  spinnerloading: boolean;
  currentProductId: string[];
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>;
  currentCartKeyId: string[];
  setCurrentCartKeyId: React.Dispatch<React.SetStateAction<string[]>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const BlockContent: React.FC<BlockContentProps> = ({
  loading,
  spinnerloading,
  currentProductId,
  setCurrentProductId,
  currentCartKeyId,
  setCurrentCartKeyId,
  setLoading,
}) => {
  const cartItems = useSelector((state: RootState) => state.shoppingcart.productdata || []);
  const settings = useSelector((state: RootState) => state.sidecartsettings.appSettings || null);
  const store = useSelector((state: RootState) => state);

  let ContentComponent = settings?.contentvariation === '/bodyelements/contentelement2'
    ? ContentElementV2
    : ContentElement;

  const renderOrderbumpElement = () => {
    if (
      cartItems &&
      cartItems.length > 0 &&
      settings &&
      settings.orderbumpsoptions &&
      settings.orderbumpsoptions.length > 0 &&
      settings.orderbumpsoptions[0].length > 0 &&
      settings.orderbumpsoptions[0][0] &&
      settings.enableorderbumps === 'on'
    ) {
      return <Orderbump settings={settings} cartItems={cartItems} />;
    }
    return null;
  };

  return (
    <>
      <div className="row p-2 mx-0 ips-sidecart-contentelement">
        <div
          className={`ips-sidecart-content ${
            spinnerloading ? 'ips-sidecart-loading-overlay' : ''
          }`}
        >
          {spinnerloading && <div className="ips-sidecart-loading-spinner"></div>}
          <div
            className="d-flex flex-column align-items-stretch"
            style={{ width: '100%' }}
          >
            <div className="list-group list-group-flush scrollarea">
              {cartItems || loading ? (
                <ContentComponent
                setTotal={undefined} // Übergeben Sie die Props nur, wenn nötig
                setTotalFormat={undefined}
                setQuantity={undefined}
                loading={loading}
                currentProductId={currentProductId}
                setCurrentProductId={setCurrentProductId}
                currentCartKeyId={currentCartKeyId}
                setCurrentCartKeyId={setCurrentCartKeyId}
                setLoading={setLoading}
                />
              ) : (
                <SkeletonEmpty settings={settings} />
              )}

              {renderOrderbumpElement()}

              <div className="list-end-element py-3 lh-tight"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockContent;